import cookie from 'vue-cookies';
import store from '@/store';
import { USER_TYPE } from '@/utils/const';
import {
  AGENT_DASHBOARD_PATH,
  CUSTOMER_DASHBOARD_PATH,
  isAgentProtectedRoute,
  isCustomerProtectedRoute,
} from '@/utils/portalJourney';

const AUTH_GETTER = 'auth/isAuthenticated';

function guardPortalAccess(to, _from, next) {
  if (!store.getters[AUTH_GETTER]) {
    next();
    return;
  }

  const { path } = to;
  const isAgent = cookie.get(USER_TYPE) === 'agent';

  if (isAgentProtectedRoute(path) && !isAgent) {
    next(CUSTOMER_DASHBOARD_PATH);
    return;
  }

  if (isCustomerProtectedRoute(path) && isAgent) {
    next(AGENT_DASHBOARD_PATH);
    return;
  }

  next();
}

export default guardPortalAccess;
